export const CourtSide = {
  Left: 'Left',
  Right: 'Right'
} as const
export type CourtSide = typeof CourtSide[keyof typeof CourtSide]